// ============================================================================
// CHINESE (TRADITIONAL) TRANSLATIONS - CHAPTER 1: 創世記
// ============================================================================
// 級別 1-13 (13個級別, 39個問題)

export const chapter1Translations = {
  name: "創世記",
  description: "起初……知識使靈魂煥發生機",
  
  spiritualWisdom: {
    principle: "知識使靈魂煥發生機",
    scripture: "我的民因無知識而滅亡 (何西阿書 4:6)",
    application: "每一節經文的學習，每一個真理的發現都滋養我們的靈魂，堅固我們的信心"
  },
  
  levels: {
    1: {
      name: "創造",
      challenge: "起初，神創造天地……",
      easy: {
        question: "神用多少天創造了世界？",
        options: ["5天", "6天", "7天", "8天"],
        hint: "想想一週中的安息日",
        funFact: "💡 第7天，神歇了祂的工。這就是安息日的起源，每週的休息日！"
      },
      medium: {
        question: "神在第四天創造了什麼？",
        options: ["動物", "人", "日月星辰", "植物"],
        hint: "這些受造物照亮大地並標記時間",
        funFact: "🌟 光體被造來定節令、日子、年歲！"
      },
      hard: {
        question: "人按照'神的形象'被造是什麼意思？",
        options: [
          "外貌相同",
          "能夠創造和愛的能力",
          "天然的不朽",
          "神聖的能力"
        ],
        hint: "這涉及屬靈和智力的品質",
        funFact: "✨ 神在我們裡面的形象包括創造力、道德意識和愛的能力！"
      }
    },
    
    2: {
      name: "園中的試探",
      challenge: "蛇是田間一切活物中最狡猾的……",
      easy: {
        question: "什麼動物在園中試探夏娃？",
        options: ["獅子", "蛇", "鷹", "龍"],
        hint: "這種動物用肚子爬行",
        funFact: "🐍 蛇原本可能有腿，但被詛咒後要用肚子爬行！"
      },
      medium: {
        question: "亞當和夏娃吃了禁果後，他們的第一個反應是什麼？",
        options: [
          "他們向神禱告",
          "他們感到羞恥並躲藏",
          "他們吃了更多",
          "他們睡著了"
        ],
        hint: "他們意識到自己的不順服",
        funFact: "👀 他們的眼睛明亮了，知道自己赤身露體！"
      },
      hard: {
        question: "這個故事關於試探教導了我們什麼？",
        options: [
          "試探是不可避免的並且是好的",
          "不順服神會帶來屬靈的死亡",
          "知識總是危險的",
          "神造人是為了讓人犯罪"
        ],
        hint: "這關乎順服和後果",
        funFact: "⚡ 罪的工價就是死，但神有恢復的計劃！"
      }
    },
    
    3: {
      name: "該隱和亞伯",
      challenge: "你兄弟亞伯在哪裡？",
      easy: {
        question: "該隱的職業是什麼？",
        options: ["牧羊人", "農夫", "漁夫", "獵人"],
        hint: "他耕種土地",
        funFact: "🌾 該隱是土地的耕種者，像他的父親亞當一樣！"
      },
      medium: {
        question: "神為什麼不悅納該隱的供物？",
        options: [
          "祭物不夠大",
          "他的心態和動機有問題",
          "他來得太晚了",
          "神偏愛亞伯"
        ],
        hint: "神看重內心而不是外在",
        funFact: "💝 神不看外貌，而是看內心的態度！"
      },
      hard: {
        question: "這個故事關於嫉妒教導了我們什麼？",
        options: [
          "嫉妒是自然的",
          "嫉妒若不加以控制會導致罪惡",
          "神喜歡製造衝突",
          "嫉妒使人更堅強"
        ],
        hint: "這關乎控制我們的負面情緒",
        funFact: "🔥 罪就伏在門前，但我們必須制伏它！"
      }
    },
    
    4: {
      name: "挪亞的洪水",
      challenge: "造一隻方舟……",
      easy: {
        question: "挪亞帶進方舟的每種潔淨動物有多少對？",
        options: ["1對", "2對", "7對", "10對"],
        hint: "比不潔淨的動物多",
        funFact: "🦁 潔淨動物7對，不潔淨的2對，為了獻祭和繁殖！"
      },
      medium: {
        question: "洪水持續了多少天？",
        options: ["30天", "40天", "100天", "150天"],
        hint: "這個數字在聖經中象徵試煉和潔淨",
        funFact: "🌊 雨下了40天，但水勢浩大共150天！"
      },
      hard: {
        question: "彩虹象徵什麼？",
        options: [
          "天氣現象",
          "神與人類立約的記號",
          "神的憤怒",
          "洪水的結束"
        ],
        hint: "這是神永恆應許的標誌",
        funFact: "🌈 彩虹是神永不再用洪水毀滅全地的約！"
      }
    },
    
    5: {
      name: "巴別塔",
      challenge: "來吧，我們要建造一座城和一座塔……",
      easy: {
        question: "人們想要建造什麼？",
        options: ["一座宮殿", "一座塔頂通天的塔", "一座橋", "一座花園"],
        hint: "他們想要到達天",
        funFact: "🏗️ 巴別塔可能是用磚砌成的金字塔形神廟！"
      },
      medium: {
        question: "神如何阻止巴別塔的建造？",
        options: [
          "祂摧毀了塔",
          "祂變亂了他們的語言",
          "祂使地震動",
          "祂派天使"
        ],
        hint: "祂使他們無法溝通",
        funFact: "🗣️ '巴別'的意思是'變亂'，因為神在那裡變亂了語言！"
      },
      hard: {
        question: "這個故事關於驕傲教導了我們什麼？",
        options: [
          "雄心總是好的",
          "驕傲和想要像神一樣會導致混亂",
          "統一總是神的旨意",
          "建造高塔是罪"
        ],
        hint: "這關乎人的驕傲與神的主權",
        funFact: "⚡ 驕傲在敗壞以先，狂心在跌倒之前！"
      }
    },
    
    6: {
      name: "亞伯拉罕的呼召",
      challenge: "你要離開本地、本族、父家，往我所要指示你的地去……",
      easy: {
        question: "神呼召亞伯拉罕離開哪裡？",
        options: ["埃及", "迦南", "吾珥", "巴比倫"],
        hint: "這是一座位於美索不達米亞的城市",
        funFact: "🏛️ 吾珥是當時一座繁華的城市，有偶像崇拜！"
      },
      medium: {
        question: "神向亞伯拉罕應許了什麼？",
        options: [
          "財富",
          "成為大國，地土和後裔",
          "長壽",
          "王位"
        ],
        hint: "三重應許：後裔、土地和祝福",
        funFact: "⭐ 神應許亞伯拉罕的後裔如天上的星那樣多！"
      },
      hard: {
        question: "亞伯拉罕的順服教導了我們關於信心的什麼？",
        options: [
          "信心需要看見所有答案",
          "信心是在不知道終點的情況下順服神",
          "信心是軟弱",
          "順服是可選的"
        ],
        hint: "這關乎信靠並跟隨神",
        funFact: "🚶 亞伯拉罕出去，還不知往哪裡去，這就是真信心！"
      }
    },
    
    7: {
      name: "以撒的獻祭",
      challenge: "神必自己預備作燔祭的羊羔……",
      easy: {
        question: "亞伯拉罕被要求獻上誰？",
        options: ["他的僕人", "他的兒子以撒", "他的妻子", "一隻羊"],
        hint: "他的獨生子，他所愛的",
        funFact: "💝 以撒是應許之子，在亞伯拉罕100歲時出生！"
      },
      medium: {
        question: "最後代替以撒被獻上的是什麼？",
        options: [
          "一頭牛",
          "一隻羊羔",
          "角扣在稠密的小樹中的公羊",
          "什麼都沒有"
        ],
        hint: "神預備了一隻替代的動物",
        funFact: "🐏 公羊被角纏住，完美地預表了基督的犧牲！"
      },
      hard: {
        question: "這個故事預表了什麼屬靈真理？",
        options: [
          "神喜悅人的獻祭",
          "神會提供祂所要求的",
          "人類犧牲取悅神",
          "亞伯拉罕真的不愛以撒"
        ],
        hint: "這關乎即使不理解也要信靠",
        funFact: "💝 當我們信靠神時，祂總是預備出路！"
      }
    },

    8: {
      name: "雅各和以掃",
      challenge: "將來大的要服事小的……",
      easy: {
        question: "以掃為什麼賣了長子的名分？",
        options: ["金子", "一碗紅豆湯", "衣服", "酒"],
        hint: "一碗用來充飢的食物",
        funFact: "🍲 一時的飢餓使以掃失去了永恆的祝福！"
      },
      medium: {
        question: "雅各如何欺騙他的父親以撒？",
        options: [
          "改變了聲音",
          "偽裝",
          "用山羊皮蓋住自己",
          "謊報名字"
        ],
        hint: "為了像他多毛的哥哥",
        funFact: "🎭 瞎眼的以撒認出了氣味和觸感，卻沒認出欺騙！"
      },
      hard: {
        question: "這個故事關於我們的選擇揭示了什麼？",
        options: [
          "欺騙有時是必要的",
          "即時的慾望可能使我們失去命定",
          "神認可狡猾",
          "小的總是被偏愛"
        ],
        hint: "這關乎我們衝動決定的後果",
        funFact: "⚖️ 我們的衝動選擇可能帶來永恆的後果！"
      }
    },

    9: {
      name: "雅各的夢",
      challenge: "夢見一個梯子立在地上，梯子的頭頂著天……",
      easy: {
        question: "雅各在夢中看到了什麼？",
        options: [
          "一棵巨樹",
          "通往天堂的梯子，上面有天使",
          "一座聖殿",
          "星星"
        ],
        hint: "天地之間的溝通方式",
        funFact: "👼 雅各的梯子象徵著天地之間的連接！"
      },
      medium: {
        question: "雅各用作枕頭的石頭，他後來怎麼處理的？",
        options: [
          "打碎了",
          "埋了",
          "立起來並澆油",
          "帶走了"
        ],
        hint: "他把它做成了神聖的紀念碑",
        funFact: "🪨 這塊石頭成為'伯特利'——神的殿！"
      },
      hard: {
        question: "這個異象如何在我們的生活中連接天地？",
        options: [
          "只通過夢",
          "通過建立與神連接的禱告",
          "通過守護天使",
          "通過聖地"
        ],
        hint: "這關乎我們與神的溝通",
        funFact: "🌉 禱告是我們通往天堂的個人梯子！"
      }
    },

    10: {
      name: "約瑟被兄弟們出賣",
      challenge: "看哪，那做夢的來了……",
      easy: {
        question: "約瑟有多少個兄弟？",
        options: ["7個兄弟", "10個兄弟", "11個兄弟", "12個兄弟"],
        hint: "比以色列支派的數目少一個",
        funFact: "👨‍👨‍👦‍👦 雅各的12個兒子將成為以色列的12個支派！"
      },
      medium: {
        question: "約瑟被賣了多少舍客勒銀子？",
        options: [
          "10舍客勒",
          "20舍客勒",
          "30舍客勒",
          "50舍客勒"
        ],
        hint: "一個奴隸的價格",
        funFact: "💰 20舍客勒銀子，當時一個奴隸的價格！"
      },
      hard: {
        question: "嫉妒如何成為神計劃的工具？",
        options: [
          "神認可嫉妒",
          "所行的惡被神轉為善",
          "嫉妒是必要的",
          "兄弟們是對的"
        ],
        hint: "這關乎神將惡轉為善的旨意",
        funFact: "🎨 神甚至把我們最壞的行為轉化為恩典的傑作！"
      }
    },

    11: {
      name: "約瑟在監獄裡",
      challenge: "耶和華與約瑟同在，向他施恩……",
      easy: {
        question: "約瑟有什麼特別的恩賜？",
        options: [
          "預言",
          "解夢",
          "醫治病人",
          "與動物說話"
        ],
        hint: "一種與夢有關的能力",
        funFact: "💭 在古代世界，夢被認為是神的信息！"
      },
      medium: {
        question: "哪些法老的臣僕與約瑟一起在監獄裡？",
        options: [
          "宰相和文士",
          "酒政和膳長",
          "醫生和守衛",
          "廚師和園丁"
        ],
        hint: "侍奉酒的和侍奉餅的",
        funFact: "🍷 酒政要先嘗王的酒，以防中毒！"
      },
      hard: {
        question: "約瑟關於在逆境中忠心教導了我們什麼？",
        options: [
          "不公正是可以接受的",
          "對神的忠心超越環境",
          "監獄改變人",
          "必須報復"
        ],
        hint: "這關乎即使在試煉中也要保持忠心",
        funFact: "⭐ 即使在監獄裡，約瑟仍保持正直，神提升了他！"
      }
    },

    12: {
      name: "法老的夢",
      challenge: "七隻肥母牛……七隻瘦母牛……",
      easy: {
        question: "有多少隻瘦母牛吃了肥母牛？",
        options: ["5隻", "6隻", "7隻", "8隻"],
        hint: "一個完全的數字",
        funFact: "🐄 數字7在聖經中象徵完全和豐盛！"
      },
      medium: {
        question: "夢中的7年意味著什麼？",
        options: [
          "7年戰爭然後和平",
          "7年豐收然後7年饑荒",
          "7年疾病然後健康",
          "7年降雨然後乾旱"
        ],
        hint: "豐盛和缺乏的循環",
        funFact: "🌾 約瑟通過這個解釋拯救了埃及和他的家人！"
      },
      hard: {
        question: "神的智慧如何轉化危機？",
        options: [
          "避免所有危機",
          "給予先見之明以便準備",
          "懲罰惡人",
          "使信徒富有"
        ],
        hint: "這關乎準備和預見",
        funFact: "💡 神的智慧將危機轉化為拯救的機會！"
      }
    },

    13: {
      name: "兄弟們的和解",
      challenge: "我是約瑟，你們所賣的兄弟……",
      easy: {
        question: "約瑟在便雅憫的口袋裡放了什麼？",
        options: [
          "金子",
          "他的戒指",
          "他的銀杯",
          "一封信"
        ],
        hint: "一個珍貴的私人物品",
        funFact: "🏆 那杯子也用來在水中'占卜'未來！"
      },
      medium: {
        question: "約瑟關於惡被轉為善說了什麼名言？",
        options: [
          "我饒恕你們",
          "從前你們的意思是要害我，但神的意思原是好的",
          "讓我們忘記過去",
          "伸冤在神"
        ],
        hint: "關於神旨意的一句話",
        funFact: "✨ 這句話總結了神在我們生命中的一切旨意！"
      },
      hard: {
        question: "饒恕如何打破復仇的循環？",
        options: [
          "忘記惡行",
          "釋放冒犯者和被冒犯者，重新開始",
          "先懲罰",
          "保持距離"
        ],
        hint: "這關乎彼此釋放",
        funFact: "🕊️ 約瑟的饒恕預表了神普世的饒恕！"
      }
    }
  }
};

export default chapter1Translations;
